import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { MenuKey } from '../../schema/menu-schema/common';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: MenuKey.LOCAL_FILE_SAVE_AS,
        content: i18n.t<string>('另存为'),
        shortcut: {
            win: 'Ctrl+Shift+S',
            mac: '⌘+Shift+S',
        },
    },
    {
        name: MenuKey.LOCAL_FILE_SAVE,
        content: i18n.t<string>('保存'),
        shortcut: {
            win: 'Ctrl+S',
            mac: '⌘+S',
        },
    },
];
